<template>
    <div v-loading="loading">
        <div class="schoolHeader">
            <div class="web clearfix">
                <div class="fl schoolHeaderBox">
                    <div>
                        <el-image style="width: 103px; height: 103px;border-radius: 8px;" :src="schoolDetail.avatar" fit="cover" />
                    </div>
                    <div class="schoolContentBox">
                        <div v-if="schoolDetail.package_id > 10">
                            <el-image style="width: 25px; height: 25px;" src="http://youpinwang.oss-cn-shenzhen.aliyuncs.com/upload/20220114/dddabccf7ab89d24bba6d87f38191afb.gif" fit="cover" />
                        </div>
                        <div class="schoolName">{{schoolDetail.name}}</div>
                        <div class="schoolContent">
                            <span>{{schoolDetail.province_name?schoolDetail.province_name:''}}{{schoolDetail.city_name?schoolDetail.city_name:''}}{{schoolDetail.dist_name?schoolDetail.dist_name:''}}</span>
                            <el-divider direction="vertical"></el-divider>
                            <span>{{schoolDetail.scale}}</span>
                            <el-divider direction="vertical" v-if="schoolDetail.company_type"></el-divider>
                            <span v-if="schoolDetail.company_type">{{company_typelist[schoolDetail.company_type - 1]}}</span>
                        </div>
                    </div>
                </div>
                <div class="fr inRecruit">
                    <div v-if="schoolDetail.JobList !== undefined">{{schoolDetail.JobList.length}}</div>
                    <div>在招职位</div>
                </div>
            </div>
        </div>
        <div class="schoolDetail">
            <div class="web">
                <el-row :gutter="10">
                    <el-col :span="18">
                        <div class="schoolDetailLeft">
                            <div class="schoolDetailTitle">园所福利</div>
                            <div class="schoolDetailBox" v-if="schoolDetail.label !== undefined && schoolDetail.label.length > 0">
                                <el-tag class="schoolLabel" v-for="(item, index) in schoolDetail.label" :key="index">{{item}}</el-tag>
                            </div>
                            <div class="schoolDetailTitle">园所介绍</div>
                            <div class="schoolDetailBox" v-html="schoolDetail.desc">{{schoolDetail.desc}}</div>
                            <div class="schoolDetailTitle">园所环境</div>
                            <div class="schoolDetailBox schoolPhoto">
                                <el-carousel indicator-position="none">
                                    <el-carousel-item v-for="(item, index) in schoolDetail.photo" :key="index">
                                        <el-image style="cursor: pointer;" @click="openPhoto(item)" :src="item.url" fit="contain" />
                                    </el-carousel-item>
                                </el-carousel>
                            </div>
                            <div class="schoolDetailTitle">园所地址</div>
                            <div class="schoolDetailBox school_address">
                                <div class="school_addressTitle"><i class="el-icon-location-outline"></i>{{schoolDetail.address}}</div>
                                <Amap v-if="schoolDetail.longitude" :longitude="schoolDetail.longitude" :latitude="schoolDetail.latitude" />
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="otherPost">
                            <div class="otherPostTitle">在招职位</div>
                            <div class="otherPostBox">
                                <div class="otherPostList" v-for="(item, index) in schoolDetail.JobList" :key="index" @click="goDetail(item)">
                                    <div>
                                        <div>
                                            <span class="job_name">{{item.job_name}}</span>
                                            <span class="salary_package">{{item.salary_package}}{{item.salary_package === '面议'?'':'元/月'}}</span>
                                        </div>
                                        <div class="school_name textOverflow">{{item.school_name}}</div>
                                    </div>
                                    <div>
                                        <el-image style="width: 62px; height: 62px" :src="schoolDetail.avatar" fit="cover" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="otherPostTitle">微信扫码查看</div>
                            <div class="weChatCode">
                                <img :src="weChatCode" alt="">
                            </div>
                            <el-divider></el-divider>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
    import Amap from '@/components/map'
    import { getWeChatCode } from '@/js/common.js'

    export default {
        components: {
            Amap
        },
        watch: {
            $route() {
                this.sid = this.$route.query.sid
                this.getSchool()
            }
        },
        data() {
            return {
                loading: true,
                sid: '',
                schoolDetail: {},
                company_typelist: ['幼儿园','早教/托育机构','综合教育公司','其他'],
                activeName: '1',
                weChatCode: ''
            }
        },
        created() {
            if(this.$route.query.sid) {
                this.sid = this.$route.query.sid
            }
            this.getSchool()
            getWeChatCode(this, 'jobjoin/pages/schoolDetail/schoolDetail', this.sid)
        },
        methods: {
            // 获取园所详情
            getSchool() {
                this.loading = true
                this.api.get('/5cfe6d594381a', { sid: this.sid }).then(r => {
                    this.loading = false
                    this.schoolDetail = r.data
                    if(this.schoolDetail.desc) {
                        this.schoolDetail.desc = this.schoolDetail.desc.replace(/↵/g, '<br>')
                        this.schoolDetail.desc = this.schoolDetail.desc.replace(/\n/g, '<br>')
                    }
                })
            },

            // 打开图片
            openPhoto(o) {
                window.open(o.url)
            },

            // 去职位详情
            goDetail(o) {
                this.$router.push({
                    path: '/job/postDetail',
                    query: {
                        jid: o.jid
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .schoolHeader {
        background: #444c5f;
        padding: 29px 0;
        .schoolContentBox {
            margin-left: 20px;
        }
        .inRecruit {
            color: white;
            text-align: center;
            >div:nth-child(1) {
                font-size: 36px;
            }
            >div:nth-child(2) {
                font-size: 14px;
            }
        }
        .schoolHeaderBox {
            >div {
                display: inline-block;
                vertical-align: middle;
            }
            .schoolName {
                font-size: 32px;
                color: white;
            }
            .schoolContent {
                color: rgba(255,255,255,.7);
                font-size: 14px;
                padding-top: 10px;
            }
        }
    }
    .schoolDetail {
        background: white;
        padding: 30px 0;
        .schoolDetailLeft {
            padding-right: 20px;
            border-right: 1px #f5f7f9 solid;
        }
        .schoolDetailTitle {
            padding-top: 20px;
            font-weight: 700;
            font-size: 15px;
            color: #424a5e;
        }
        .schoolDetailTitle::after {
            content: '';
            height: 2px;
            background: #ff5b12;
            width: 22px;
            display: block;
            margin-top: 10px;
        }
        .schoolDetailBox {
            padding-top: 10px;
            color: #51586d;
            font-size: 14px;
            .schoolLabel {
                margin-right: 5px;
            }
        }
        .school_address {
            margin-top: 10px;
            box-shadow: 0 0 10px rgba(0,0,0,.1);
            .school_addressTitle {
                padding-left: 25px;
                color: #62687a;
                padding: 13px 15px 11px 35px;
            }
        }
        .schoolPhoto {
            width: 70%;
        }
    }
    .otherPost {
        .otherPostList {
            padding: 18px 0;
            border-bottom: 1px solid #f5f7f9;
            cursor: pointer;
            >div {
                display: inline-block;
                vertical-align: middle;
            }
            >div:nth-child(1) {
                width: 73%;
                margin-right: 3%;
            }
            .salary_package {
                color: #fc703e;
            }
            .school_name {
                color: #9fa3af;
                padding-top: 12px;
                width: 210px;
            }
        }
        .otherPostList:last-child {
            border-bottom: none;
        }
        .otherPostList:hover {
            .job_name {
                color: #fc703e;
            }
        }
    }

    .weChatCode {
        text-align: center;
        img {
            width: 50%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/job/schoolDetail.vue